const supportedCountries = [
  {
    countryCode: 'AD',
    languages: ['es', 'fr', 'pt', 'en'],
  },
  {
    countryCode: 'AE',
    languages: ['en'],
  },
  {
    countryCode: 'AF',
    languages: ['en'],
  },
  {
    countryCode: 'AG',
    languages: ['en'],
  },
  {
    countryCode: 'AI',
    languages: ['en'],
  },
  {
    countryCode: 'AL',
    languages: ['it', 'en'],
  },
  {
    countryCode: 'AM',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'AO',
    languages: ['pt'],
  },
  {
    countryCode: 'AR',
    languages: ['es'],
  },
  {
    countryCode: 'AS',
    languages: ['en'],
  },
  {
    countryCode: 'AT',
    languages: ['de'],
  },
  {
    countryCode: 'AU',
    languages: ['en'],
  },
  {
    countryCode: 'AW',
    languages: ['es', 'en'],
  },
  {
    countryCode: 'AZ',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'BA',
    languages: ['en'],
  },
  {
    countryCode: 'BB',
    languages: ['en'],
  },
  {
    countryCode: 'BD',
    languages: ['en'],
  },
  {
    countryCode: 'BE',
    languages: ['fr', 'de', 'en'],
  },
  {
    countryCode: 'BF',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'BG',
    languages: ['ru', 'de', 'en'],
  },
  {
    countryCode: 'BH',
    languages: ['en'],
  },
  {
    countryCode: 'BI',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'BJ',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'BL',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'BM',
    languages: ['en', 'pt'],
  },
  {
    countryCode: 'BN',
    languages: ['en'],
  },
  {
    countryCode: 'BO',
    languages: ['es'],
  },
  {
    countryCode: 'BR',
    languages: ['pt'],
  },
  {
    countryCode: 'BS',
    languages: ['en'],
  },
  {
    countryCode: 'BT',
    languages: ['en'],
  },
  {
    countryCode: 'BW',
    languages: ['en'],
  },
  {
    countryCode: 'BY',
    languages: ['ru'],
  },
  {
    countryCode: 'BZ',
    languages: ['es', 'en'],
  },
  {
    countryCode: 'CA',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'CC',
    languages: ['en'],
  },
  {
    countryCode: 'CD',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'CF',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'CG',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'CH',
    languages: ['de', 'fr', 'it', 'en'],
  },
  {
    countryCode: 'CI',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'CK',
    languages: ['en'],
  },
  {
    countryCode: 'CL',
    languages: ['es'],
  },
  {
    countryCode: 'CM',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'CN',
    languages: ['zh'],
  },
  {
    countryCode: 'CO',
    languages: ['es'],
  },
  {
    countryCode: 'CR',
    languages: ['es'],
  },
  {
    countryCode: 'CU',
    languages: ['es'],
  },
  {
    countryCode: 'CV',
    languages: ['pt'],
  },
  {
    countryCode: 'CW',
    languages: ['es', 'en'],
  },
  {
    countryCode: 'CX',
    languages: ['zh', 'en'],
  },
  {
    countryCode: 'CY',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'CZ',
    languages: ['de', 'ru', 'en'],
  },
  {
    countryCode: 'DE',
    languages: ['de', 'en'],
  },
  {
    countryCode: 'DJ',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'DK',
    languages: ['de', 'en'],
  },
  {
    countryCode: 'DM',
    languages: ['en'],
  },
  {
    countryCode: 'DO',
    languages: ['es'],
  },
  {
    countryCode: 'DZ',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'EC',
    languages: ['es'],
  },
  {
    countryCode: 'EE',
    languages: ['ru', 'es'],
  },
  {
    countryCode: 'EG',
    languages: ['fr', 'es'],
  },
  {
    countryCode: 'EH',
    languages: ['fr', 'es'],
  },
  {
    countryCode: 'ER',
    languages: ['it', 'es'],
  },
  {
    countryCode: 'ES',
    languages: ['es'],
  },
  {
    countryCode: 'ET',
    languages: ['en'],
  },
  {
    countryCode: 'FI',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'FJ',
    languages: ['en'],
  },
  {
    countryCode: 'FK',
    languages: ['es', 'en'],
  },
  {
    countryCode: 'FM',
    languages: ['en'],
  },
  {
    countryCode: 'FO',
    languages: ['de', 'en'],
  },
  {
    countryCode: 'FR',
    languages: ['fr'],
  },
  {
    countryCode: 'GA',
    languages: ['fr'],
  },
  {
    countryCode: 'GB',
    languages: ['en'],
  },
  {
    countryCode: 'GD',
    languages: ['en'],
  },
  {
    countryCode: 'GE',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'GF',
    languages: ['fr'],
  },
  {
    countryCode: 'GH',
    languages: ['en'],
  },
  {
    countryCode: 'GI',
    languages: ['es', 'en'],
  },
  {
    countryCode: 'GL',
    languages: ['en'],
  },
  {
    countryCode: 'GM',
    languages: ['en'],
  },
  {
    countryCode: 'GN',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'GP',
    languages: ['fr'],
  },
  {
    countryCode: 'GQ',
    languages: ['es', 'fr', 'pt', 'en'],
  },
  {
    countryCode: 'GR',
    languages: ['de', 'fr', 'it', 'en'],
  },
  {
    countryCode: 'GT',
    languages: ['es'],
  },
  {
    countryCode: 'GU',
    languages: ['es'],
  },
  {
    countryCode: 'GW',
    languages: ['pt', 'en'],
  },
  {
    countryCode: 'GY',
    languages: ['en'],
  },
  {
    countryCode: 'HN',
    languages: ['es'],
  },
  {
    countryCode: 'HR',
    languages: ['de', 'en'],
  },
  {
    countryCode: 'HT',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'HU',
    languages: ['de', 'ru', 'fr', 'en'],
  },
  {
    countryCode: 'ID',
    languages: ['en'],
  },
  {
    countryCode: 'IE',
    languages: ['en'],
  },
  {
    countryCode: 'IL',
    languages: ['en'],
  },
  {
    countryCode: 'IN',
    languages: ['en'],
  },
  {
    countryCode: 'IQ',
    languages: ['en'],
  },
  {
    countryCode: 'IR',
    languages: ['en'],
  },
  {
    countryCode: 'IS',
    languages: ['de', 'en'],
  },
  {
    countryCode: 'IT',
    languages: ['it'],
  },
  {
    countryCode: 'JM',
    languages: ['en'],
  },
  {
    countryCode: 'JO',
    languages: ['en'],
  },
  {
    countryCode: 'JP',
    languages: ['ja'],
  },
  {
    countryCode: 'KE',
    languages: ['en'],
  },
  {
    countryCode: 'KG',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'KH',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'KI',
    languages: ['en'],
  },
  {
    countryCode: 'KM',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'KN',
    languages: ['en'],
  },
  {
    countryCode: 'KP',
    languages: ['ko'],
  },
  {
    countryCode: 'KR',
    languages: ['ko'],
  },
  {
    countryCode: 'KW',
    languages: ['en'],
  },
  {
    countryCode: 'KY',
    languages: ['en'],
  },
  {
    countryCode: 'KZ',
    languages: ['ru'],
  },
  {
    countryCode: 'LA',
    languages: ['it', 'en'],
  },
  {
    countryCode: 'LB',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'LC',
    languages: ['en'],
  },
  {
    countryCode: 'LI',
    languages: ['de'],
  },
  {
    countryCode: 'LK',
    languages: ['en'],
  },
  {
    countryCode: 'LR',
    languages: ['en'],
  },
  {
    countryCode: 'LS',
    languages: ['en'],
  },
  {
    countryCode: 'LT',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'LU',
    languages: ['pt', 'fr', 'de', 'it', 'en'],
  },
  {
    countryCode: 'LV',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'LY',
    languages: ['it', 'ko', 'fr', 'en'],
  },
  {
    countryCode: 'MA',
    languages: ['fr', 'es', 'en', 'it'],
  },
  {
    countryCode: 'MC',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'MD',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'MF',
    languages: ['fr', 'es', 'en'],
  },
  {
    countryCode: 'MG',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'MH',
    languages: ['en'],
  },
  {
    countryCode: 'MK',
    languages: ['fr', 'de', 'ru', 'en'],
  },
  {
    countryCode: 'ML',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'MM',
    languages: ['zh', 'en'],
  },
  {
    countryCode: 'MN',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'MP',
    languages: ['zh', 'en'],
  },
  {
    countryCode: 'MQ',
    languages: ['fr'],
  },
  {
    countryCode: 'MR',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'MS',
    languages: ['en'],
  },
  {
    countryCode: 'MU',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'MV',
    languages: ['en'],
  },
  {
    countryCode: 'MX',
    languages: ['es'],
  },
  {
    countryCode: 'MY',
    languages: ['zh', 'en'],
  },
  {
    countryCode: 'MZ',
    languages: ['pt', 'en'],
  },
  {
    countryCode: 'NA',
    languages: ['en'],
  },
  {
    countryCode: 'NC',
    languages: ['fr'],
  },
  {
    countryCode: 'NE',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'NF',
    languages: ['en'],
  },
  {
    countryCode: 'NG',
    languages: ['en'],
  },
  {
    countryCode: 'NI',
    languages: ['es'],
  },
  {
    countryCode: 'NL',
    languages: ['de', 'fr', 'en'],
  },
  {
    countryCode: 'NO',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'NP',
    languages: ['en'],
  },
  {
    countryCode: 'NR',
    languages: ['en'],
  },
  {
    countryCode: 'NU',
    languages: ['en'],
  },
  {
    countryCode: 'NZ',
    languages: ['en'],
  },
  {
    countryCode: 'OM',
    languages: ['en'],
  },
  {
    countryCode: 'PA',
    languages: ['es'],
  },
  {
    countryCode: 'PE',
    languages: ['es'],
  },
  {
    countryCode: 'PF',
    languages: ['fr'],
  },
  {
    countryCode: 'PG',
    languages: ['en'],
  },
  {
    countryCode: 'PH',
    languages: ['es', 'en'],
  },
  {
    countryCode: 'PK',
    languages: ['en'],
  },
  {
    countryCode: 'PL',
    languages: ['de', 'ru', 'fr', 'en'],
  },
  {
    countryCode: 'PM',
    languages: ['fr'],
  },
  {
    countryCode: 'PN',
    languages: ['en'],
  },
  {
    countryCode: 'PR',
    languages: ['es'],
  },
  {
    countryCode: 'PS',
    languages: ['en'],
  },
  {
    countryCode: 'PT',
    languages: ['pt'],
  },
  {
    countryCode: 'PY',
    languages: ['es'],
  },
  {
    countryCode: 'QA',
    languages: ['en'],
  },
  {
    countryCode: 'RO',
    languages: ['fr', 'it', 'de', 'ru', 'en'],
  },
  {
    countryCode: 'RU',
    languages: ['ru'],
  },
  {
    countryCode: 'RW',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'SA',
    languages: ['en'],
  },
  {
    countryCode: 'SB',
    languages: ['en'],
  },
  {
    countryCode: 'SC',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'SD',
    languages: ['en'],
  },
  {
    countryCode: 'SE',
    languages: ['de', 'fr', 'en'],
  },
  {
    countryCode: 'SG',
    languages: ['zh', 'en'],
  },
  {
    countryCode: 'SI',
    languages: ['de', 'it', 'en'],
  },
  {
    countryCode: 'SJ',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'SK',
    languages: ['de', 'ru', 'en'],
  },
  {
    countryCode: 'SL',
    languages: ['en'],
  },
  {
    countryCode: 'SM',
    languages: ['it'],
  },
  {
    countryCode: 'SN',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'SO',
    languages: ['it', 'en'],
  },
  {
    countryCode: 'SR',
    languages: ['es', 'pt', 'en'],
  },
  {
    countryCode: 'ST',
    languages: ['pt'],
  },
  {
    countryCode: 'SV',
    languages: ['es'],
  },
  {
    countryCode: 'SY',
    languages: ['en'],
  },
  {
    countryCode: 'SZ',
    languages: ['en'],
  },
  {
    countryCode: 'TC',
    languages: ['es', 'en'],
  },
  {
    countryCode: 'TD',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'TG',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'TH',
    languages: ['zh', 'en'],
  },
  {
    countryCode: 'TJ',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'TK',
    languages: ['en'],
  },
  {
    countryCode: 'TM',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'TN',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'TO',
    languages: ['en'],
  },
  {
    countryCode: 'TR',
    languages: ['en'],
  },
  {
    countryCode: 'TT',
    languages: ['en'],
  },
  {
    countryCode: 'TV',
    languages: ['en'],
  },
  {
    countryCode: 'TW',
    languages: ['zh'],
  },
  {
    countryCode: 'TZ',
    languages: ['en'],
  },
  {
    countryCode: 'UA',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'UG',
    languages: ['en'],
  },
  {
    countryCode: 'US',
    languages: ['en', 'es'],
  },
  {
    countryCode: 'UZ',
    languages: ['ru', 'en'],
  },
  {
    countryCode: 'UY',
    languages: ['es'],
  },
  {
    countryCode: 'VA',
    languages: ['it', 'fr', 'de', 'en'],
  },
  {
    countryCode: 'VC',
    languages: ['en'],
  },
  {
    countryCode: 'VE',
    languages: ['es'],
  },
  {
    countryCode: 'VG',
    languages: ['en'],
  },
  {
    countryCode: 'VI',
    languages: ['en'],
  },
  {
    countryCode: 'VN',
    languages: ['zh', 'en'],
  },
  {
    countryCode: 'VU',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'WF',
    languages: ['fr', 'en'],
  },
  {
    countryCode: 'WS',
    languages: ['en'],
  },
  {
    countryCode: 'YE',
    languages: ['en'],
  },
  {
    countryCode: 'ZA',
    languages: ['en'],
  },
  {
    countryCode: 'ZM',
    languages: ['en'],
  },
  {
    countryCode: 'ZW',
    languages: ['en'],
  },
]

export const getCountryLanguageSelectOptions = (t) => {
  const countryLangaugeOptions = []
  supportedCountries.forEach((country) => {
    country.languages.forEach((language) => {
      const value = `${country.countryCode.toLowerCase()}_${language}`
      const countryTrans = t(`global.countries.country${country.countryCode}`, country.countryCode)
      const langTrans = t(`global.countries.language.${language}`)
      const primaryText = `${countryTrans} - ${langTrans}`
      countryLangaugeOptions.push({
        key: value,
        value,
        primaryText,
      })
    })
  })
  return countryLangaugeOptions
}

export default supportedCountries
